export default "__VITE_PUBLIC_ASSET__d1763682__"